import styled from 'styled-components';

export const PageHeaders = styled.h2`
    font-family: 'Pangolin', cursive;
`

export const InfoHeader = styled.h3`
    font-family: 'Pangolin', cursive;
`